import React from "react";

const SubFilter = ({ onFilter }) => {
	// Ref
	const fromRef = React.createRef();
	const toRef = React.createRef();

	return (
		<div className="form-row">
			<div className="col">
				<label htmlFor="from">Date Range From:</label>
				<input
					type="date"
					className="form-control input-height"
					id="from"
					ref={fromRef}
					placeholder="From"
				/>
			</div>
			<div className="col">
				<label htmlFor="to">Date Range To:</label>
				<input
					type="date"
					className="form-control input-height"
					id="to"
					ref={toRef}
					onChange={() => {
						onFilter({
							dateRange: {
								from: fromRef.current.value,
								to: toRef.current.value
							}
						});
					}}
					placeholder="To"
				/>
			</div>
		</div>
	);
};
export default SubFilter;
